// extracted by mini-css-extract-plugin
module.exports = {"container":"graphic_card_container__2Rm89","iconArea":"graphic_card_iconArea__31-vR","infoArea":"graphic_card_infoArea__2Tz9G","number":"graphic_card_number__kzfVN"};